import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/faucet.svg'


const _hoisted_1 = { style: {"padding":"50px"} }
const _hoisted_2 = { style: {"font-weight":"700"} }
const _hoisted_3 = { style: {"font-size":"1.25rem","white-space":"pre-line"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"center","align-items":"center","margin-top":"60px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: "Image",
  style: {"width":"30px"}
}, null, -1 /* HOISTED */)
const _hoisted_6 = { style: {"display":"flex","justify-content":"center","align-items":"center","margin-top":"20px"} }
const _hoisted_7 = { ref: "root" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('FAUCET.TITLE')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('FAUCET.WELCOME')), 1 /* TEXT */),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          placeholder: $setup.i18n.t('FAUCET.INPUT_ADDRESS'),
          style: {"width":"70%"},
          modelValue: $setup.address,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.address) = $event))
        }, null, 8 /* PROPS */, ["placeholder", "modelValue"]),
        _createVNode(_component_Button, {
          class: "p-button p-component secondary",
          disabled: $setup.recaptchaToken.length==0,
          onClick: $setup.topup
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('FAUCET.REQUEST_TOKENS')) + " ", 1 /* TEXT */),
            _hoisted_5
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, null, 512 /* NEED_PATCH */)
      ])
    ])
  ]))
}